var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	38352: () => (loadSingletonVersion("default", "@angular/core-angular-21", false, [4,21,2,0], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs-_b2701").then(() => (() => (__webpack_require__(49460))))))),
	9634: () => (loadSingletonVersion("default", "rxjs-angular-21", false, [1,7,0,0], () => (__webpack_require__.e("node_modules_rxjs_dist_esm_index_js").then(() => (() => (__webpack_require__(31340))))))),
	92830: () => (loadSingletonVersion("default", "rxjs/operators-angular-21", false, [1,7,0,0], () => (__webpack_require__.e("node_modules_rxjs_dist_esm_operators_index_js").then(() => (() => (__webpack_require__(23620))))))),
	32698: () => (loadSingleton("default", "@angular/core/primitives/signals-angular-21", false, () => (__webpack_require__.e("node_modules_angular_core_fesm2022_primitives-signals_mjs-_767e1").then(() => (() => (__webpack_require__(36699))))))),
	16778: () => (loadSingletonVersion("default", "@angular/common-angular-21", false, [4,21,2,0], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_common_mjs-_b2b92").then(() => (() => (__webpack_require__(21352))))))),
	95980: () => (loadSingletonVersion("default", "@angular/common/http-angular-21", false, [4,21,2,0], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_http_mjs-_bbfc2").then(() => (() => (__webpack_require__(16613))))))),
	9322: () => (loadSingletonVersion("default", "@angular/animations/browser-angular-21", false, [4,21,2,0], () => (__webpack_require__.e("node_modules_angular_animations_fesm2022_browser_mjs-_af7a1").then(() => (() => (__webpack_require__(11887))))))),
	89737: () => (loadSingletonVersion("default", "@angular/platform-browser-angular-21", false, [4,21,2,0], () => (__webpack_require__.e("node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f2").then(() => (() => (__webpack_require__(80436))))))),
	7058: () => (loadSingletonVersion("default", "@angular/core-angular-21", false, [0,16,0,0], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs-_b2702").then(() => (() => (__webpack_require__(49460))))))),
	79774: () => (loadSingletonVersion("default", "@angular/platform-browser/animations-angular-21", false, [4,21,2,0], () => (__webpack_require__.e("node_modules_angular_platform-browser_fesm2022_animations_mjs-_f32a0").then(() => (() => (__webpack_require__(43835))))))),
	3566: () => (loadSingletonVersion("default", "@angular/core-angular-21", false, [1,21,1,2], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs-_b2700").then(() => (() => (__webpack_require__(49460))))))),
	7602: () => (loadSingletonVersion("default", "@angular/core/rxjs-interop-angular-21", false, [1,21,1,2], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_rxjs-interop_mjs-_b06f0").then(() => (() => (__webpack_require__(49074))))))),
	29876: () => (loadSingletonVersion("default", "@angular/common-angular-21", false, [1,21,1,2], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_common_mjs-_b2b90").then(() => (() => (__webpack_require__(21352))))))),
	80469: () => (loadSingletonVersion("default", "@angular/core-angular-21", false, [1,21,0,0], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs-_b2700").then(() => (() => (__webpack_require__(49460))))))),
	3197: () => (loadSingletonVersion("default", "@angular/core/rxjs-interop-angular-21", false, [1,21,0,0], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_rxjs-interop_mjs-_b06f0").then(() => (() => (__webpack_require__(49074))))))),
	20858: () => (loadSingletonVersion("default", "@ngx-translate/core-angular-21", false, [1,15,0,0], () => (__webpack_require__.e("node_modules_ngx-translate_core_dist_fesm2022_ngx-translate-core_mjs-_63780").then(() => (() => (__webpack_require__(90852))))))),
	19499: () => (loadSingletonVersion("default", "lodash-angular-21", true, [1,4,17,21], () => (() => (__webpack_require__(46227))))),
	1118: () => (loadSingletonVersion("default", "@angular/router-angular-21", false, [4,21,2,0], () => (__webpack_require__.e("node_modules_angular_router_fesm2022_router_mjs-_1fef0").then(() => (() => (__webpack_require__(17415))))))),
	44944: () => (loadSingletonVersion("default", "@angular/forms-angular-21", false, [4,21,2,0], () => (__webpack_require__.e("node_modules_angular_forms_fesm2022_forms_mjs-_0f7c0").then(() => (() => (__webpack_require__(34456))))))),
	37380: () => (loadSingletonVersion("default", "@angular/animations-angular-21", false, [4,21,2,0], () => (__webpack_require__.e("node_modules_angular_animations_fesm2022_animations_mjs-_d6a80").then(() => (() => (__webpack_require__(47172))))))),
	52177: () => (loadSingletonVersion("default", "@angular/core-angular-21", false, [,[1,22,0,0],[1,21,0,0],1], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs-_b2700").then(() => (() => (__webpack_require__(49460))))))),
	69043: () => (loadSingletonVersion("default", "@angular/common-angular-21", false, [,[1,22,0,0],[1,21,0,0],1], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_common_mjs-_b2b90").then(() => (() => (__webpack_require__(21352))))))),
	59730: () => (loadSingletonVersion("default", "@angular/platform-browser-angular-21", false, [,[1,22,0,0],[1,21,0,0],1], () => (__webpack_require__.e("node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f0").then(() => (() => (__webpack_require__(80436))))))),
	46884: () => (loadSingletonVersion("default", "@angular/core-angular-21", false, [0,14,0,0], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs-_b2700").then(() => (() => (__webpack_require__(49460))))))),
	59238: () => (loadSingletonVersion("default", "@angular/common-angular-21", false, [0,14,0,0], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_common_mjs-_b2b90").then(() => (() => (__webpack_require__(21352))))))),
	29252: () => (loadSingletonVersion("default", "@angular/forms-angular-21", false, [0,14,0,0], () => (__webpack_require__.e("node_modules_angular_forms_fesm2022_forms_mjs-_0f7c0").then(() => (() => (__webpack_require__(34456))))))),
	85422: () => (loadSingletonVersion("default", "@angular/core-angular-21", false, [0,12,0,0], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs-_b2700").then(() => (() => (__webpack_require__(49460))))))),
	42012: () => (loadSingletonVersion("default", "@angular/common-angular-21", false, [0,12,0,0], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_common_mjs-_b2b90").then(() => (() => (__webpack_require__(21352))))))),
	93160: () => (loadSingletonVersion("default", "fhir-typescript-models-angular-21", false, [1,1,0,3], () => (__webpack_require__.e("node_modules_fhir-typescript-models_dist_src_models_all_js").then(() => (() => (__webpack_require__(13017))))))),
	66986: () => (loadSingletonVersion("default", "@angular/common/http-angular-21", false, [1,21,1,2], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_http_mjs-_bbfc0").then(() => (() => (__webpack_require__(16613))))))),
	74935: () => (loadSingletonVersion("default", "@angular/platform-browser-angular-21", false, [1,21,1,2], () => (__webpack_require__.e("node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f0").then(() => (() => (__webpack_require__(80436))))))),
	91780: () => (loadSingletonVersion("default", "@angular/platform-browser/animations-angular-21", false, [1,21,1,2], () => (__webpack_require__.e("node_modules_angular_platform-browser_fesm2022_animations_mjs-_f32a0").then(() => (() => (__webpack_require__(43835))))))),
	70352: () => (loadSingletonVersion("default", "@angular/router-angular-21", false, [1,21,1,2], () => (__webpack_require__.e("node_modules_angular_router_fesm2022_router_mjs-_1fef0").then(() => (() => (__webpack_require__(17415))))))),
	35341: () => (loadSingletonVersion("default", "rxjs/operators-angular-21", false, [1,7,0,0], () => (__webpack_require__.e("node_modules_aw_bootstrap-utils_node_modules_rxjs_dist_esm_operators_index_js-_36ef0").then(() => (() => (__webpack_require__(75351))))))),
	16801: () => (loadSingletonVersion("default", "rxjs-angular-21", false, [1,7,0,0], () => (__webpack_require__.e("node_modules_aw_bootstrap-utils_node_modules_rxjs_dist_esm_index_js-_259c0").then(() => (() => (__webpack_require__(48911))))))),
	26044: () => (loadSingletonVersion("default", "@angular/core/rxjs-interop-angular-21", false, [4,21,2,0], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_rxjs-interop_mjs-_b06f0").then(() => (() => (__webpack_require__(49074))))))),
	70168: () => (loadSingletonVersion("default", "@angular/common-angular-21", false, [,[4,8,0,0],0,[0,8,0,0],2], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_common_mjs-_b2b90").then(() => (() => (__webpack_require__(21352))))))),
	28010: () => (loadSingletonVersion("default", "@angular/core-angular-21", false, [,[4,8,0,0],0,[0,8,0,0],2], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs-_b2700").then(() => (() => (__webpack_require__(49460))))))),
	45973: () => (loadSingletonVersion("default", "@angular/core-angular-21", false, [1,21,1,5], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs-_b2700").then(() => (() => (__webpack_require__(49460))))))),
	3645: () => (loadSingletonVersion("default", "@angular/core/rxjs-interop-angular-21", false, [1,21,1,5], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_rxjs-interop_mjs-_b06f0").then(() => (() => (__webpack_require__(49074))))))),
	65657: () => (loadSingletonVersion("default", "@angular/forms-angular-21", false, [1,21,1,5], () => (__webpack_require__.e("node_modules_angular_forms_fesm2022_forms_mjs-_0f7c0").then(() => (() => (__webpack_require__(34456))))))),
	70615: () => (loadSingletonVersion("default", "@angular/common-angular-21", false, [1,21,1,5], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_common_mjs-_b2b90").then(() => (() => (__webpack_require__(21352))))))),
	10569: () => (loadSingletonVersion("default", "rxjs/webSocket-angular-21", false, [1,7,8,1], () => (__webpack_require__.e("node_modules_rxjs_dist_esm_webSocket_index_js").then(() => (() => (__webpack_require__(86749))))))),
	61225: () => (loadSingletonVersion("default", "@angular/common/http-angular-21", false, [1,21,1,5], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_http_mjs-_bbfc0").then(() => (() => (__webpack_require__(16613))))))),
	51764: () => (loadSingletonVersion("default", "@angular/platform-browser-angular-21", false, [1,21,1,5], () => (__webpack_require__.e("node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f0").then(() => (() => (__webpack_require__(80436))))))),
	53102: () => (loadSingletonVersion("default", "rxjs-angular-21", false, [1,7,0,0], () => (__webpack_require__.e("node_modules_aw_tla-event-util_node_modules_rxjs__esm2015_index_js").then(() => (() => (__webpack_require__(5075)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"node_modules_angular_animations_fesm2022_animations_mjs-_d6a81": [
		38352
	],
	"node_modules_angular_animations_fesm2022_browser_mjs-_af7a0": [
		38352
	],
	"node_modules_angular_common_fesm2022_common_mjs-_b2b91": [
		9634,
		38352
	],
	"node_modules_angular_common_fesm2022_http_mjs-_bbfc1": [
		9634,
		38352,
		92830
	],
	"node_modules_angular_core_fesm2022_core_mjs-_b2701": [
		9634,
		32698,
		92830
	],
	"node_modules_angular_core_fesm2022_rxjs-interop_mjs-_b06f1": [
		9634,
		92830,
		32698
	],
	"node_modules_angular_forms_fesm2022_forms_mjs-_0f7c1": [
		38352,
		16778,
		9634,
		92830
	],
	"node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f1": [
		16778,
		38352,
		95980
	],
	"node_modules_angular_platform-browser_fesm2022_animations_mjs-_f32a1": [
		38352,
		9322,
		16778
	],
	"node_modules_angular_router_fesm2022_router_mjs-_1fef1": [
		16778,
		38352,
		9634,
		92830,
		89737
	],
	"node_modules_ngx-translate_core_dist_fesm2022_ngx-translate-core_mjs-_63781": [
		7058,
		9634,
		92830
	],
	"src_bootstrap_ts": [
		38352,
		89737,
		95980,
		79774,
		3566,
		9634,
		7602,
		29876,
		92830,
		80469,
		3197,
		20858,
		19499,
		1118,
		16778,
		44944,
		37380,
		52177,
		69043,
		59730,
		46884,
		59238,
		29252,
		85422,
		42012,
		93160
	],
	"node_modules_angular_common_fesm2022_common_mjs-_b2b92": [
		9634
	],
	"node_modules_angular_common_fesm2022_http_mjs-_bbfc2": [
		9634,
		92830
	],
	"node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f2": [
		95980
	],
	"node_modules_angular_core_fesm2022_core_mjs-_b2702": [
		32698
	],
	"node_modules_angular_core_fesm2022_core_mjs-_b2700": [
		32698
	],
	"node_modules_angular_core_fesm2022_rxjs-interop_mjs-_b06f0": [
		32698
	],
	"node_modules_ngx-translate_core_dist_fesm2022_ngx-translate-core_mjs-_63780": [
		7058
	],
	"node_modules_angular_platform-browser_fesm2022_animations_mjs-_f32a0": [
		9322
	],
	"src_app_modules_spa_component_module_ts-_7eb11": [
		66986,
		74935,
		91780,
		70352,
		35341,
		16801,
		26044,
		70168,
		28010,
		45973,
		3645,
		65657,
		70615,
		10569,
		61225,
		51764,
		53102
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}